import ProgressionInputFieldComponent from "./ProgressionInputFieldComponent";

const ProgressionInput = (props) => (
  <div className={`progression-input${props.unchecked ? " unchecked" : ""}`}>
    <ProgressionInputFieldComponent {...props} />
  </div>
);

export default ProgressionInput;
